import Header from '@components/Header';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import EventContent from './components/EventContent';
import EventHeader from './components/EventHeader';
import useEvent from './hooks/useEvent';

interface Params {
    eventId: string;
}

const EventActivity: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
  const { eventId } = params;
  const event = useEvent(eventId);
  return (
      <AppScreen >
          <Header title='이벤트'/>
          {event ? (
              <Fragment>
                  <EventHeader event={event}/>
                  <EventContent event={event}/>
              </Fragment>
          ) : (<Loading/>)}
      </AppScreen>
  );
};

export default EventActivity;
